import {
  ClipboardList,
  FolderKanban,
  FileText,
  UserCheck,
  Award,
  GraduationCap,
  Briefcase,
  Users,
  ShieldCheck,
} from "lucide-react";

function StudentBenefits() {
  const benefits = [
    {
      icon: <ClipboardList size={36} />,
      title: "Practical Assignments",
      desc: "Learn by doing with hands-on assignments after every module.",
    },
    {
      icon: <FolderKanban size={36} />,
      title: "Live Industry Projects",
      desc: "Work on real-world projects to gain practical experience.",
    },
    {
      icon: <Briefcase size={36} />,
      title: "Portfolio Development",
      desc: "Build an impressive portfolio to showcase your skills.",
    },
    {
      icon: <UserCheck size={36} />,
      title: "Interview Preparation",
      desc: "Mock interviews and placement guidance from experts.",
    },
    
  ];

  return (
    <section
      id="benefits"
      className="py-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Heading */}

        <div className="text-center mb-16">

          <span className="bg-blue-100 text-blue-700 px-5 py-2 rounded-full font-semibold">
            Student Benefits
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold mt-6 text-gray-900">
            Everything You Need to
            <span className="text-blue-700"> Succeed</span>
          </h2>

          <p className="mt-5 text-gray-600 max-w-3xl mx-auto leading-8">
            We go beyond teaching by providing career-focused support,
            practical exposure, and mentorship to help you achieve your goals.
          </p>

        </div>

        {/* Cards */}

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">

          {benefits.map((item, index) => (

            <div
              key={index}
              className="group bg-white border border-blue-100 rounded-3xl p-8 shadow-md hover:shadow-2xl hover:border-blue-600 transition-all duration-300 hover:-translate-y-2"
            >

              <div className="w-16 h-16 rounded-2xl bg-blue-100 text-blue-700 flex items-center justify-center group-hover:bg-blue-700 group-hover:text-white transition">

                {item.icon}

              </div>

              <h3 className="mt-6 text-2xl font-bold text-gray-900">
                {item.title}
              </h3>

              <p className="mt-4 text-gray-600 leading-7">
                {item.desc}
              </p>

            </div>

          ))}

        </div>

      </div>
    </section>
  );
}

export default StudentBenefits;